export class UnionServiceDelegation {
    constructor(
        id,
        name,
        deletedAt
    ) {
        this.id = id;
        this.name = name;
        this.deletedAt = deletedAt;
    }
    static createFromResponseData(data) {
        return new UnionServiceDelegation(
            data.id,
            data.name,
            data.deletedAt
        );
    }
}
